import { ValueCalculator } from "./value-calculator";

export class MeanPidCalculator extends ValueCalculator {
  constructor(Kp, range) {
    super(0);
    this.Kp = Kp;
    this.elements = [];
    this.elements.length = range;
    this.elements.fill(0);
    this.sum = 0;
    this.elementCount = 0;
    this.range = range;
    this.index = 0;
    this.meanValue = 0;
  }

  calculate(setpoint) {
    this.measuredValue += this.Kp * (setpoint - this.measuredValue);
    if (this.elementCount < this.range) {
      this.elements[this.elementCount] = this.measuredValue;
      this.elementCount++;
    } else {
      this.sum -= this.elements[this.index];
      this.elements[this.index] = this.measuredValue;
      this.index++;
      if (this.index == this.range) {
        this.index = 0;
      }
    }
    this.sum += this.measuredValue;
    this.meanValue = this.sum / this.elementCount;
    return this.meanValue;
  }

  reset(initValue) {
    this.measuredValue = initValue;
    this.sum = initValue;
    this.elements[0] = initValue;
    this.elementCount = 1;
    this.index = 1;
    this.meanValue = initValue;
  }
}
